<!--
 * @Author: cgh
 * @Date: 2022-09-23
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 15:00:19
 * @Description: 项目转移
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-70 o-dialog--lg-60 o-dialog--xl-50"
    title="项目转移"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <section>
      <el-form
        ref="fd"
        class="c-form"
        :model="fd"
        :rules="fdRules"
        :inline="true"
        label-position="right"
        label-width="150px"
        label-suffix="："
      >
        <el-row class="c-form__row">
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目名称"
              prop="xmmc"
            >
              <span class="c-form__read">
                {{ fd.xmmc }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="委托单位"
              prop="wtdw"
            >
              <span
                class="c-form__read"
              >
                {{ fd.wtdw || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="建筑类型"
              prop="jzlxMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.jzlxMc || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="评估日期"
              prop="pgrq"
            >
              <span
                class="c-form__read"
              >
                {{ fd.pgrqqStr || '-' }} 至 {{ fd.pgrqzStr || '-' }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="项目负责人"
              prop="xmfzrMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmfzrMc || '-' }}
              </span>
            </el-form-item>
          </el-col>

          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="所属账号"
              prop="sszhMc"
            >
              <el-select
                v-model="fd.sszhDm"
                clearable
                value-key="value"
                placeholder="请选择所属账号"
              >
                <el-option
                  v-for="item in userList"
                  :key="item.capacityCode"
                  :label="item.capacityName"
                  :value="item.capacityCode"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="创建时间"
              prop="cjsj"
            >
              <span
                class="c-form__read"
              >
                {{ fd.cjsj | date('yyyy-MM-dd HH:mm:ss') }}
              </span>
            </el-form-item>
          </el-col>
          <el-col
            class="c-form__col"
            :span="24"
          >
            <el-form-item
              class="c-form__item"
              label="当前状态"
              prop="xmztMc"
            >
              <span
                class="c-form__read"
              >
                {{ fd.xmztMc || '-' }}
              </span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </section>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleTranslateXm()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { pgxmManageService } from './pgxm.service.js';

// 继承于新增用户
export default {
  name: 'PgTranslateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      dialogShow: true, // 模态框dialog显示
      userList: [], // 可转移用户列表
      loading: false, // 页面是否加载
      fd: {
        id: '',
        xmmc: '',
        wtdw: '',
        bgbh: '',
        jzlxMc: '',
        pgrq: '',
        xmfzrMc: '',
        jzs: '',
        sszhMc: '',
        sszhDm: '',
        cjsj: '',
        xmztMc: ''
      },

      /* 表单校验规则 Start */
      fdRules: {
        sszhDm: [
          this.$validUtils.required('所属账号')
        ]
      }
      /* 表单校验规则 End */
    };
  },
  methods: {
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    },

    /**
     * @description: 项目转移
     * @return {*}
     */
    handleTranslateXm () {
      const _this = this;
      _this.loading = true;
      var _params = {
        xmId: _this.fd.id,
        capacityCode: _this.fd.sszhDm
      };
      pgxmManageService.translate(_params)
        .then(rsp => {
          _this.$alert('项目转移成功', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('评估项目转移失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * @description: 获取项目可转移用户列表
     * @return {*}
     */
    handleTranslateUsers () {
      const _this = this;
      pgxmManageService.getTranslateUsers(_this.fd.id)
        .then(rsp => {
          _this.userList = rsp.data;
        })
        .catch(err => {
          console.error('获取项目可转移用户列表失败！', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * @description: 初始化
     * @return {*}
     */
    init () {
      this.handleTranslateUsers();
    }
  },
  created () {
    this.fd = this.dlParams;
    this.init();
  }
};
</script>
